import { appContainer } from '../contexts/app';
import { List } from 'immutable';
import Resource from './resource';
import {
  fromImmutable,
  toImmutable,
  setInState,
  setListInState,
  deleteInState,
  hydrateParent,
  validate
} from './hooks';

const hydrateBuilding = hydrateParent('api/buildings', 'building_id');

export default app => {
  const service = app.service('api/floors');
  // Lengthen the timeout to allow for image uploads
  service.timeout = 20000;

  const FloorRecord = Resource(
    service,
    {
      account_id: '',
      building_id: '',
      name: '',
      geo: {},
      overlay: {
        image: {
          path: 'https://via.placeholder.com/400x400',
          name: '',
          key: ''
        },
        heading: 0,
        opacity: 1
      }
    },
    {
      markers() {
        const markers = appContainer.state.get('markers');
        if (!markers) {
          return List();
        }
        return markers.toList().filter(marker => marker.floor_id === this._id);
      }
    }
  );

  const validateFloor = validate({
    name: 'Floor name is required.',
    'overlay.image.path': 'An image is required.'
  });

  appContainer.FloorRecord = FloorRecord;
  app.set('FloorRecord', FloorRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateFloor],
      update: [fromImmutable, validateFloor],
      patch: [fromImmutable, validateFloor],
      remove: []
    },

    after: {
      all: [toImmutable(FloorRecord)],
      find: [setListInState('floors')],
      get: [setInState('floors')],
      create: [setInState('floors'), hydrateBuilding],
      update: [setInState('floors')],
      patch: [setInState('floors')],
      remove: [deleteInState('floors'), hydrateBuilding]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/floors.js